






































import axios from 'axios';
import Entidad from '@/models/Entidad';
export default {
	name: 'admindialog',
	inject: ['responsive'],
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		entidadadmin: {
			type: String,
		},
	},
	data() {
		return {
			show: false,
			entidadadmin2: '',
			loadingentidad: false,
			loadentitychange: false,
			entidades: [],
			ruleForm: {
				codent: '',
			},
			rules: {
				codent: [{ required: true, message: 'Debe tipear una entidad.', trigger: 'blur' }],
			},
		};
	},
	watch: {
		visible(v) {
			this.show = v;
		},
	},
	computed: {
		userdata() {
			return this.$store.state.perfil.userdata;
		},
		codent() {
			return this.$store.state.perfil.codent;
		},
	},
	methods: {
		remoteMethod(query: String): void {
			if (query !== '' && query.length > 3) {
				this.loadingentidad = true;
				this.entidades = [];
				this.$store.dispatch('callEntitiesPatron', query).then((response: Entidad[]) => {
					this.entidades = response;
					this.loadingentidad = false;
				});
			} else this.entidades = [];
		},
		onSubmit(): void {
			this.$refs['ruleForm'].validate((valid: boolean) => {
				if (valid) {
					this.loadentitychange = true;
					const entidad = this.entidades.filter((ent: Entidad) => {
						return ent.codent == this.$refs['ruleForm'].model.codent;
					});
					this.$store.dispatch('setEntidadSelected', entidad[0]);
					axios.defaults.headers.common.Entity_ID = this.$refs['ruleForm'].model.codent;
					this.$emit('closed');
					if (this.$route.name === 'Dashboard') {
						this.$store
							.dispatch('loadPorlets', {
								url: 'etenet_dashboard',
							})
							.then(() => {
								this.tableResumenGranosFilter = this.tableResumenGranos.filter(item => {
									return item.kilstk !== 0;
								});
								//this.loadingDashboard = false;
							});
					} else this.$router.push('/1/dashboard');
					this.loadentitychange = false;
				}
			});
		},
		onClosed(): void {
			this.$refs['ruleForm'].resetFields();
			this.$emit('closed');
			this.show = false;
		},
	},
};
